import {Component, Input, OnInit} from '@angular/core';
import {FlatArea} from '../../../models/flat-area.model';

@Component({
  selector: 'app-flat-coverage-selector',
  templateUrl: './flat-coverage-selector.component.html',
  styleUrls: ['./flat-coverage-selector.component.scss']
})
export class FlatCoverageSelectorComponent implements OnInit {

  @Input() flatArea: FlatArea;
  coverageTypes: string[] = [
    'greslap', 'laminált parketta', 'fagyálló burkolat'
  ];

  constructor() {
  }

  ngOnInit() {
  }

}
